"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    en: {
        ASSEMBLY_SIGNATURE: {
            description: 'The photo montage you made will not be accepted by the CFE (centre de formalité des entreprises), and your application will be refused. Please try again by hand written the text and signing the document',
            label: 'Photo montage signature',
        },
        BIRTH_BOROUGH_MISSING: {
            description: "Your birth city borough mush be specified. The CFE (centre de formalité des entreprises) may refuse your application if it's not present.",
            label: 'Birth borough missing',
        },
        BIRTH_PLACE_MISSING: {
            description: 'Your birth city must be specified, as well as the department and the borough (if any).',
            label: 'Birth place missing',
        },
        BIRTH_ZIP_MISSING: {
            description: "The ZIP code of your birth city must be specified. The CFE (centre de formalité des entreprises) may refuse your application if it's not present.",
            label: 'Birth zip missing',
        },
        BLACK_AND_WHITE: {
            description: 'Can‘t be black and white, nor a photo of a screen',
            label: 'Black and white',
        },
        BLURRY: {
            description: 'The photo of your document is blurry',
            label: 'Blurry',
        },
        CITY_MENTION: {
            description: 'City of signature is invalid',
            label: 'City of signature missing',
        },
        CONTRACT_COMM_LEASE_INVALID: {
            description: 'Your document is not valid, plase add your commercial lease',
            label: 'Invalid',
        },
        CONTRACT_DOM_INVALID: {
            description: 'Your document is not valid, plase add your domiciliation contract',
            label: 'Invalid',
        },
        CONTRACT_INCOMPLETE: {
            description: 'Your document is incomplete, please upload all your contract',
            label: 'Incomplete',
        },
        CROPPED: {
            description: 'The photo of your document is cropped. The whole document should be visible inside the photo frame (all borders visible)',
            label: 'Cropped',
        },
        DECLARANT_CHECKED: {
            description: 'Please check declarant box',
            label: 'Declarant box checked',
        },
        DIPLOMA_BOX: {
            description: 'Diploma box checked and indication of the qualified person (most often = declarant). If employee or other, identity indicated on the right.',
            label: 'Diploma box not checked',
        },
        DIPLOMA_INVALID: {
            description: 'The document is invalid, it must be a diploma or proof of experience of more than 3 years',
            label: 'Invalid diploma',
        },
        DRIVING_LICENSE_NOT_SUPPORTED: {
            description: 'Driving license is not accepted, please provide use with another ID.',
            label: 'Driving license',
        },
        DRIVING_LICENSE_RECTO_INVALID: {
            description: 'The downloaded document is not the correct one, please add your driving license on the front.',
            label: 'Front Driving license invalid',
        },
        DRIVING_LICENSE_VERSO_INVALID: {
            description: 'The downloaded document is not the correct one, please add your driving license on the back.',
            label: 'Back Driving license invalid',
        },
        EMPTY_DOCUMENT: {
            description: 'The document you sent us is empty. Please fill it.',
            label: 'Empty document',
        },
        EXPIRED: {
            description: 'Your document expired, or is older than 3 months',
            label: 'expired',
        },
        EXPIRED_ID: {
            description: 'The ID is expired, please provide us with a new document and an ID which is not expired',
            label: 'Expired ID',
        },
        FALSIFIED: {
            description: 'This document does not seem to be an original. Please provide another document',
            label: 'Falsified',
        },
        GENERIC: {
            description: 'Unknown document error',
            // Will be overridden by entity errorLocalized
            label: 'Other',
        },
        HANDWRITTEN_MENTION: {
            description: 'The mention must be handwritten. Please write it by hand and send us the document again.',
            label: 'Handwritten mention',
        },
        HANDWRITTEN_SIGNATURE: {
            description: 'Your signature must be made in original and correspond to your identity document. You can sign your document by hand, handwritten or using a digital pen.',
            label: 'Not handwritten (character font)',
        },
        ID_INVALID: {
            description: 'Your document is invalid. Please add from your application a valid document in the following list: French or EU passport (photo on both pages), French national identity card or of a member country of the EU front and back, Residence permit valid on both sides, Residence permit expired front and back accompanied by its valid receipt.',
            label: 'City missing',
        },
        ID_RECTO_OWNER_INVALID: {
            description: 'The document is invalid, it must be the back-side ID of your owner.',
            label: 'Invalid Id recto owner',
        },
        ID_VERSO_OWNER_INVALID: {
            description: 'The document is invalid, it must be the front-side ID of your owner.',
            label: 'Invalid Id verso owner',
        },
        INCONSISTENT_ACTIVITY: {
            description: 'The activity indicated on the document does not correspond to the one chosen as part of the sending of your formality. Please indicate the right activity.',
            label: 'Inconsistent activity',
        },
        INCONSISTENT_DATE: {
            description: 'Please note, the date indicated after "from" must be before or equal to the date of signature.',
            label: 'Inconsistent date after "from"',
        },
        INCONSISTENT_MARITAL_STATUS: {
            description: 'The marital status provided during your signup is inconsistent with the document. If you made a mistake during the signup, please contact us.',
            label: 'Inconsistent marital status',
        },
        INCONSISTENT_RESIDENCE_PERMIT_DATE: {
            description: 'It seems that the date indicated on your proof does not make sense with the residence permit sent.',
            label: 'Residence permit expiration date inconsistent',
        },
        INCORRECT_ADDRESS: {
            description: 'We have noticed an error on the given address. The latter must correspond to the one indicated during your registration.',
            label: 'Incorrect address',
        },
        INCORRECT_BIRTH_CITY: {
            description: 'Your city of birth does not match your ID. Please correct it.',
            label: 'Incorrect birth city',
        },
        INCORRECT_FIRST_FORENAME: {
            description: 'Your first forename must be present on the document',
            label: 'Incorrect first forename',
        },
        INCORRECT_FIRST_NAME: {
            description: 'Your firstname does not exactly corresponds to your ID. Please correct it',
            label: 'Complete firstname',
        },
        INCORRECT_LAST_NAME: {
            description: 'Your lastname does not exactly corresponds to your ID. Please correct it',
            label: 'Complete lastname',
        },
        INCORRECT_NAME: {
            description: "The name or the firstname isn't yours or is incomplete. Please provide us with an updated document",
            label: 'Incorrect name',
        },
        INCORRECT_OWNER_FIRST_NAME: {
            description: 'Your owner’s first name does not exactly match the certificate of availability. Please correct it.',
            label: 'Complete owner’s firstname',
        },
        INCORRECT_OWNER_LAST_NAME: {
            description: 'Your owner’s last name does not exactly match the certificate of availability. Please correct it.',
            label: 'Complete owner’s lastname',
        },
        INTERLEAVE_BOX: {
            description: 'Please check the "Interleave" box at the top of the document.',
            label: 'Interleave box checked',
        },
        INVALID_DATE: {
            description: 'The date is invalid. Please use the format day/month/year.',
            label: 'Invalid date',
        },
        JQPA_INVALID: {
            description: 'Your document is not valid, plase add your JQPA form',
            label: 'Invalide',
        },
        MARRIAGE_INVALID: {
            description: 'The document does not correspond to what has been requested, it must be a marriage certificate / PACS with the mention "separation of property"',
            label: 'Invalid marriage / pacs contract',
        },
        MISSING: {
            description: 'This document is required in order to complete your registration',
            label: 'Missing',
        },
        MISSING_BIKE_KEYWORD: {
            description: 'The keyword "bike delivery" is missing. We cannot accept companies creation for motorized vehicules. A training lasting several hours is required. Please fix your statement or contact us if you need more information about the training.',
            label: 'Motorized delivery',
        },
        MISSING_CITY: {
            description: 'The text "Fait à [city]" is missing.',
            label: 'City missing',
        },
        MISSING_DATE: {
            description: 'The document must have a date (day, month, year).',
            label: 'Date missing',
        },
        MISSING_ID: {
            description: 'The ID must be present on the document (recto/verso if it is not a passport).',
            label: 'ID missing',
        },
        MISSING_MARITAL_STATUS: {
            description: 'The marital status must be checked on the document. Otherwise, the CFE (centre de formalité des entreprises) may refuse your application.',
            label: 'Checkbox unchecked',
        },
        MISSING_MENTION: {
            description: 'The mention "J’atteste sur l’honneur que la copie de cette pièce d’identité est conforme à l’originale" is required on the document.',
            label: 'Missing mention',
        },
        MISSING_OWNER_ADDRESS: {
            description: 'Please ask your owner to indicate their domiciliation address below their name.',
            label: 'Missing owner’s address',
        },
        MISSING_PARENT_FIRST_NAME: {
            description: 'First names of your parents must be specified. Otherwise, the CFE (centre de formalité des entreprises) may refuse your application.',
            label: 'Parent first name missing',
        },
        MISSING_PROPERTY_SEPARATION: {
            description: 'The document is invalid, it must be a marriage certificate / PACS with the mention "separation of property"',
            label: 'Missing separation of property mention',
        },
        MISSING_SIGNATURE: {
            description: 'The document must be signed',
            label: 'Missing signature',
        },
        MISSING_TITLE: {
            description: 'The title of the document is missing. Add "Authorization to communicate to third parties" at the top of the document.',
            label: 'Missing title',
        },
        MOTHER_SAME_NAME: {
            description: 'Please specify the birth name of your mother (before mariage). If her birth name is the same as your father, add the mention "nom de famille identique". Otherwise, the CFE (centre de formalité des entreprises) may refuse your application.',
            label: 'Mother same name',
        },
        NEED_ANOTHER: {
            description: 'This document is invalid',
            label: 'Invalid',
        },
        NO_DATE: {
            description: 'Document has to be dated (and be no more than 3 months old)',
            label: 'No date',
        },
        NO_SIGNATURE: {
            description: 'Signature is not visible on this document',
            label: 'No signature',
        },
        ONE_BOX_CHECKED: {
            description: 'Please tick a box on the form.',
            label: 'One box checked',
        },
        ONE_OR_TWO_BOX_CHECKED: {
            description: 'Please check one of the two boxes or both boxes depending on your owner’s choice.',
            label: 'One or two boxes checked',
        },
        PARENTS_MARITAL_STATUS: {
            description: "The marital status seems to be your parent's one. You must specify yours.",
            label: 'Parents marital status',
        },
        PARENTS_SAME_LINE: {
            description: 'Please write your parents names on two different lines. Otherwise, the CFE (centre de formalité des entreprises) may refuse your application.',
            label: 'Same line',
        },
        PHOTO_MONTAGE: {
            description: 'Photo montages cannot be accepted. Please provide us with a unique document.',
            label: 'Photo montage',
        },
        PROOF_OF_REQUEST_ADDRESS_CHANGE_INVALID: {
            description: 'The document does not correspond to what was requested of you, it must be an email or a letter showing that you have made an appointment with the prefecture or that your change of address on your residence permit is in progress.',
            label: 'Missing proof of request address change',
        },
        PROOF_PROVISION_OWNER_INVALID: {
            description: 'The document is invalid, it must be the certificate of availability from your owner',
            label: 'Proof of provision from owner is invalid',
        },
        PROOF_RADIATION_INVALID: {
            description: 'The document is invalid, please add proof of deregistration of your old EI: letter from URSSAF or from the social security of the self-employed.',
            label: 'Invalid proof of radiation',
        },
        PROPERTY_TAX_INCOMPLETE: {
            description: 'Your document is incomplete. Please upload the entire document (4 pages).',
            label: 'Incomplete',
        },
        READ_AND_APPROVED_MISSING: {
            description: 'Missing "Read and Approved" mention',
            label: 'Missing Read and Approved',
        },
        SCREENSHOT: {
            description: 'Screenshots cannot be accepted. Please provide us with the original document.',
            label: 'Screenshot',
        },
        SIGNATURE_DATE: {
            description: 'The date of signature of the document must be less than 3 months old in the format DD/MM/YY or DD/MM/YYYY.',
            label: 'Date de signature less of 3 months',
        },
        SIGNATURE_DOES_NOT_MATCH: {
            description: 'The signature on the document does not match the one on te ID.',
            label: 'Signature do not match',
        },
        TITLE_MISSING: {
            description: 'The title of the document is missing. Please add it. Otherwise, the CFE (centre de formalité des entreprises) may refuse your application.',
            label: 'Title missing',
        },
        TYPE_NOT_SUPPORTED: {
            description: 'This document type is not part of the list of supported documents',
            label: 'Document not supported',
        },
        UNKNOWN_PARENT: {
            description: 'If you are born from unknown father or mother, please write so ("parent inconnu"). Otherwise, the CFE (centre de formalité des entreprises) may refuse your application.',
            label: 'Unknown parent',
        },
        UNREADABLE: {
            description: 'We couldn‘t verify the authenticity of the document. Make sure all the information is readable',
            label: 'Unreadable',
        },
        UPLOAD_ERROR: {
            description: 'An error occurred with this document: we cannot open it. Please send us the document again.',
            label: 'Upload error',
        },
        VITALE_CARD_INVALID: {
            description: 'The document is invalid, please add your vitale card or a social security certificate with YOUR legible social security number.',
            label: 'Invalid vitale card',
        },
        VTC_CARD_RECTO_INVALID: {
            description: 'The downloaded document is not the correct one, please add your VTC card on the front',
            label: 'Invalid Front VTC Card',
        },
        VTC_CARD_VERSO_INVALID: {
            description: 'The downloaded document is not the correct one, please add your VTC card on the back',
            label: 'Invalid Back VTC Card',
        },
        WRONG_BIRTH_DATE: {
            description: 'The birth date written does not match your ID.',
            label: 'Wrong birth date',
        },
        WRONG_ID: {
            description: 'The ID is not yours. Please send us the document with your ID.',
            label: 'Wrong ID',
        },
        WRONG_MARITAL_STATUS: {
            description: 'The word used for your marital status is not accepted and the CFE (centre de formalité des entreprises) may refuse your application. If you are separated, please write if you are single, divorced or widower.',
            label: 'Wrong marital status',
        },
    },
    fr: {
        ASSEMBLY_SIGNATURE: {
            description: 'Le montage que vous avez fait ne sera pas accepté par le CFE (centre de formalités des entreprises), et votre dossier risque d’être refusé. Nous vous invitons à recommencer en écrivant bien à la main la mention manuscrite et en signant le document.',
            label: 'Montage photo signature',
        },
        BIRTH_BOROUGH_MISSING: {
            description: 'L’arrondissement de votre ville de naissance doit être renseigné. Le CFE (centre de formalités des entreprises) risque de refuser votre dossier s’il n’est pas présent.',
            label: 'Arrondissement manquant',
        },
        BIRTH_PLACE_MISSING: {
            description: 'La ville de naissance doit être renseignée, ainsi que le département et l’arrondissement (si présent).',
            label: 'Ville naissance manquante',
        },
        BIRTH_ZIP_MISSING: {
            description: 'Le code postal de votre ville de naissance doit être renseigné sur le document. Le CFE (centre de formalités des entreprises) risque de refuser votre dossier s’il n’est pas présent.',
            label: 'Code postal manquant',
        },
        BLACK_AND_WHITE: {
            description: 'Le document ne peut pas être en noir et blanc ou être une photo d‘un écran',
            label: 'Noir et blanc',
        },
        BLURRY: {
            description: 'La photo de votre document est floue',
            label: 'Flou',
        },
        CITY_MENTION: {
            description: ' La ville de signature est invalide.',
            label: 'Ville de signature manquante',
        },
        CONTRACT_COMM_LEASE_INVALID: {
            description: 'Le document téléchargé n’est pas le bon, veuillez ajouter votre bail commercial',
            label: 'Invalide',
        },
        CONTRACT_DOM_INVALID: {
            description: 'Le document téléchargé n’est pas le bon, veuillez ajouter votre contrat de domiciliation',
            label: 'Invalide',
        },
        CONTRACT_INCOMPLETE: {
            description: 'Votre document est incomplet, merci de charger l’intégralité des de votre contrat',
            label: 'Incomplet',
        },
        CROPPED: {
            description: 'La photo de votre document est rognée. Votre document doit être entièrement visible dans le cadre de la photo (bordures visibles)',
            label: 'Rogné',
        },
        DECLARANT_CHECKED: {
            description: 'Merci de cocher la case déclarant',
            label: 'Case déclarant cochée',
        },
        DIPLOMA_BOX: {
            description: 'Merci de cocher la case diplôme en 3B et d’indiquer correctement la personne qualifiée (cocher "déclarant" s’il s’agit de vous-même).',
            label: 'Case diplôme non cochée',
        },
        DIPLOMA_INVALID: {
            description: 'Le document est invalide, il doit s’agir d’un diplôme ou justificatif d’expérience de plus de 3 ans',
            label: 'Diplôme invalide',
        },
        DRIVING_LICENSE_NOT_SUPPORTED: {
            description: 'Le permis de conduire n’est pas accepté, nous vous invitons à nous envoyer une autre pièce d’identité.',
            label: 'Permis de conduire',
        },
        DRIVING_LICENSE_RECTO_INVALID: {
            description: 'Le document téléchargé n’est pas le bon, veuillez ajouter votre permis de conduire recto.',
            label: 'Permis de conduire recto invalide',
        },
        DRIVING_LICENSE_VERSO_INVALID: {
            description: 'Le document téléchargé n’est pas le bon, veuillez ajouter votre permis de conduire verso.',
            label: 'Permis de conduire verso invalide',
        },
        EMPTY_DOCUMENT: {
            description: 'Le document que vous nous avez envoyé n’est pas rempli.',
            label: 'Document vide',
        },
        EXPIRED: {
            description: 'Votre document a expiré ou date de plus de 3 mois',
            label: 'Expiré',
        },
        EXPIRED_ID: {
            description: 'La pièce d’identité est expirée, nous vous invitons à nous renvoyer le document avec une pièce d’identité en cours de validité.',
            label: 'Pièce d’identité expirée',
        },
        FALSIFIED: {
            description: 'Le document fourni semble ne pas être un original. Veuillez nous fournir un autre document',
            label: 'Falsifié',
        },
        GENERIC: {
            description: 'Erreur inconnue',
            // Will be overridden by entity errorLocalized
            label: 'Autre',
        },
        HANDWRITTEN_MENTION: {
            description: 'La mention doit être manuscrite. Nous vous invitons à l’écrire à la main et à nous renvoyer le document.',
            label: 'Mention manuscrite',
        },
        HANDWRITTEN_SIGNATURE: {
            description: 'Votre signature doit être réalisée en originale et correspondre à votre pièce d’identité. Vous pouvez signer votre document à la main de façon manuscrite ou via un stylet numérique.',
            label: 'Non manuscrite (police de caractère)',
        },
        ID_INVALID: {
            description: 'Votre document est invalide. Merci d’ajouter depuis votre application un document en cours de validité dans la liste suivante: Passeport français ou d’un pays membre de l’UE (photo des deux pages), Carte d’identité nationale française ou d’un pays membre de l’UE recto et verso, Titre de séjour en cours de validité recto et verso, Titre de séjour expiré recto et verso accompagné de son récépissé en cours de validité.',
            label: 'Pièce d’identité invalide',
        },
        ID_RECTO_OWNER_INVALID: {
            description: 'Le document est invalide, il doit s’agir de la pièce d’identité recto du votre propriétaire.',
            label: 'Invalide',
        },
        ID_VERSO_OWNER_INVALID: {
            description: 'Le document est invalide, il doit s’agir de la pièce d’identité verso du votre propriétaire.',
            label: 'Invalide',
        },
        INCONSISTENT_ACTIVITY: {
            description: 'L’activité indiquée sur le document ne correspond pas à celle choisie dans le cadre de l’envoi de votre formalité. Merci d’indiquer la bonne activité.',
            label: 'Activité incohérente',
        },
        INCONSISTENT_DATE: {
            description: 'Attention, la date indiquée après "à compter du" doit être antérieure ou égale à la date de signature.',
            label: 'Date "A compter du" inconsistante',
        },
        INCONSISTENT_MARITAL_STATUS: {
            description: 'Le statut matrimonial indiqué lors de votre inscription est incohérent avec les informations indiquées sur le document. Si vous vous êtes trompé lors de votre inscription, nous vous invitons à nous contacter et à nous confirmer votre statut matrimonial.',
            label: 'Informations incohérentes',
        },
        INCONSISTENT_RESIDENCE_PERMIT_DATE: {
            description: 'Il semblerait que la date indiquée sur votre justificatif ne fasse pas sens avec le titre de séjour envoyé',
            label: 'Date d’expitation titre de séjour incohérente',
        },
        INCORRECT_ADDRESS: {
            description: 'Nous avons remarqué une erreur sur l’adresse indiquée. Cette dernière doit correspondre à celle indiquée lors de votre inscription',
            label: 'Adresse incorrecte',
        },
        INCORRECT_BIRTH_CITY: {
            description: 'Votre ville de naissance ne correspond pas à votre pièce d’identité. Merci de la corriger.',
            label: 'Ville de naissance correcte',
        },
        INCORRECT_FIRST_FORENAME: {
            description: 'Votre premier prénom doit être indiqué sur le document.',
            label: 'Premier prénom manquant',
        },
        INCORRECT_FIRST_NAME: {
            description: 'Votre prénom ne correspond pas exactement à votre pièce d’identité. Merci de le corriger.',
            label: 'Prénom complet présent',
        },
        INCORRECT_LAST_NAME: {
            description: 'Votre nom de famille ne correspond pas exactement à votre pièce d’identité. Merci de le corriger.',
            label: 'Nom de famille complet présent',
        },
        INCORRECT_NAME: {
            description: 'Le nom ou le prénom renseigné ne correspondent pas au vôtre ou est incomplet. Nous vous invitons à nous envoyer le document mis à jour.',
            label: 'Nom incorrect',
        },
        INCORRECT_OWNER_FIRST_NAME: {
            description: 'Le prénom de votre propriétaire ne correspond pas exactement à à l’attestation de mise à disposition. Merci de le corriger.',
            label: 'Prénom du propriétaire complet présent',
        },
        INCORRECT_OWNER_LAST_NAME: {
            description: 'Le nom de famille de votre propriétaire ne correspond pas exactement à l’attestation de mise à disposition. Merci de le corriger.',
            label: 'Nom de famille du propriétaire complet présent',
        },
        INTERLEAVE_BOX: {
            description: 'Merci de cocher la case "Intercalaire" en haut du document.',
            label: 'Case intercalaire cochée',
        },
        INVALID_DATE: {
            description: 'La date indiquée n’est pas valide. Merci d’utiliser le format jour/mois/année.',
            label: 'Date incorrecte',
        },
        JQPA_INVALID: {
            description: 'Le document téléchargé n’est pas le bon, veuillez ajouter votre formulaire JQPA',
            label: 'Invalide',
        },
        MARRIAGE_INVALID: {
            description: 'Le document ne correspond pas à ce qui vous a été demandé, il doit s’agir d’un acte de mariage/pacs avec la mention "séparation de biens"',
            label: 'Contrat de mariage ou pacs invalide',
        },
        MISSING: {
            description: 'Ce document est nécessaire pour finaliser votre inscription',
            label: 'Document manquant',
        },
        MISSING_BIKE_KEYWORD: {
            description: 'Le terme "livraison à vélo" est manquant. Nous ne sommes pas en mesure pour le moment de prendre en charge les créations pour les livreurs motorisés. Une formation de plusieurs heures est nécessaire. Nous vous invitons à rectifier cette déclaration ou à nous contacter pour en savoir plus sur la formation.',
            label: 'Livraison motorisée',
        },
        MISSING_CITY: {
            description: 'La mention "Fait à [ville]" doit être présente sur le document.',
            label: 'Ville manquante',
        },
        MISSING_DATE: {
            description: 'Le document doit être daté (jour, mois et année).',
            label: 'Date manquante',
        },
        MISSING_ID: {
            description: 'La pièce d’identité doit être présente sur le document (recto/verso s’il s’agit d’une carte d’identité).',
            label: 'Pièce d’identité absente',
        },
        MISSING_MARITAL_STATUS: {
            description: 'Le statut matrimonial doit être coché sur le document. Autrement, le CFE (centre de formalités des entreprises) risque de refuser votre dossier.',
            label: 'Case non cochée',
        },
        MISSING_MENTION: {
            description: 'La mention "J’atteste sur l’honneur que la copie de cette pièce d’identité est conforme à l’originale" doit être obligatoirement présente sur le document.',
            label: 'Mention manquante',
        },
        MISSING_OWNER_ADDRESS: {
            description: 'Merci de demander à votre propriétaire d’indiquer son adresse de domiciliation en dessous de son nom.',
            label: 'Adresse du propriétaire manquante',
        },
        MISSING_PARENT_FIRST_NAME: {
            description: 'Le prénom de vos parents doit être précisé. Autrement, le CFE (centre de formalités des entreprises) risque de refuser votre dossier.',
            label: 'Prénom d’un parent manquant',
        },
        MISSING_PROPERTY_SEPARATION: {
            description: 'Le document est invalide, il doit s’agir d’un acte de mariage/pacs avec la mention "séparation de biens"',
            label: 'Mention séparation de biens manquante',
        },
        MISSING_SIGNATURE: {
            description: 'Le document doit être signé pour que nous puissions le valider.',
            label: 'Signature manquante',
        },
        MISSING_TITLE: {
            description: 'Le titre du document est manquant. Ajouter "Autorisation à communiquer à des tiers" en haut du document.',
            label: 'Titre manquant',
        },
        MOTHER_SAME_NAME: {
            description: 'Veuillez indiquer le nom de naissance de votre mère (avant mariage). Si son nom de naissance est identique au nom de votre père, indiquez le nom et prénom de votre mère et entre parenthèses la mention "nom de famille identique". Autrement, le CFE (centre de formalités des entreprises) refusera votre dossier.',
            label: 'Nom de naissance manquant',
        },
        NEED_ANOTHER: {
            description: 'Ce document est invalide.',
            label: 'Invalide',
        },
        NO_DATE: {
            description: 'Le document doit être daté (et dater de moins de 3 mois)',
            label: 'Date manquante',
        },
        NO_SIGNATURE: {
            description: 'La signature n‘est pas visible sur le document fourni',
            label: 'Signature manquante',
        },
        ONE_BOX_CHECKED: {
            description: 'Merci de bien vouloir cocher une case sur le formulaire.',
            label: 'Une case cochée',
        },
        ONE_OR_TWO_BOX_CHECKED: {
            description: 'Merci de cocher l’une des deux cases ou les deux cases selon le choix de votre propriétaire.',
            label: 'Une ou deux cases cochées',
        },
        PARENTS_MARITAL_STATUS: {
            description: 'Le statut matrimonial renseigné semble être celui de vos parents. Vous devez renseigner le vôtre.',
            label: 'Situation des parents',
        },
        PARENTS_SAME_LINE: {
            description: 'Veuillez saisir le prénom et le nom de vos parents sur leurs lignes respectives. Autrement, le CFE (centre de formalités des entreprises) risque de refuser votre dossier.',
            label: 'Même ligne',
        },
        PHOTO_MONTAGE: {
            description: 'Les montages photo ne sont pas acceptés. Merci de nous fournir un unique document.',
            label: 'Montage photo',
        },
        PROOF_OF_REQUEST_ADDRESS_CHANGE_INVALID: {
            description: 'Le document ne correspond pas à ce qui vous a été demandé, il doit s’agir d’un courrier électronique ou d’une lettre démontrant que vous avez pris rendez-vous avec la préfecture ou que votre changement d’adresse sur votre titre de séjour est en cours.',
            label: 'Preuve de demande de changement d’adresse invalide',
        },
        PROOF_PROVISION_OWNER_INVALID: {
            description: ' Le document est invalide, il doit s’agir de l’attestation de mise à disposition de votre propriétaire',
            label: 'Attestation de mise à disposition de votre propriétaire invalide',
        },
        PROOF_RADIATION_INVALID: {
            description: 'Le document est invalide, merci d’ajouter une preuve de radiation de votre ancienne EI : lettre de l’URSSAF ou de la sécurité sociale des indépendants.',
            label: 'Preuve de radiation invalide',
        },
        PROPERTY_TAX_INCOMPLETE: {
            description: 'Votre document est incomplet. Merci de télécharger le document dans son intégralité (4 pages).',
            label: 'Taxe foncière incomplète',
        },
        READ_AND_APPROVED_MISSING: {
            description: 'Mention "Lu et Approuvé" manquante',
            label: 'Mention Lu et approuvé manquante',
        },
        SCREENSHOT: {
            description: 'Les captures d’écran ne sont pas acceptées. Merci de nous fournir le document original.',
            label: 'Screenshot',
        },
        SIGNATURE_DATE: {
            description: 'La date de signature du document doit dater de moins 3 mois sous le format JJ/MM/AA ou JJ/MM/AAAA.',
            label: 'Date de signature de moins de 3 mois',
        },
        SIGNATURE_DOES_NOT_MATCH: {
            description: 'La signature sur le document ne correspond pas à celle de la pièce d’identité.',
            label: 'Signature incohérente',
        },
        TITLE_MISSING: {
            description: 'Le titre du document doit être présent. Nous vous invitons à le rajouter. Autrement, le CFE (centre de formalités des entreprises) risque de refuser votre dossier.',
            label: 'Titre manquant',
        },
        TYPE_NOT_SUPPORTED: {
            description: 'Ce type de document ne fait pas partie des documents acceptés',
            label: 'Document non supporté',
        },
        UNKNOWN_PARENT: {
            description: 'Si vous êtes né·e de père ou de mère inconnus, nous vous invitons à le préciser (parent inconnu). Le CFE (centre de formalités des entreprises) risque de refuser votre dossier si vous n’inscrivez rien.',
            label: 'Parent inconnu',
        },
        UNREADABLE: {
            description: 'La qualité de la photo ne nous permet pas de vérifier l‘authenticité du document. Toutes les informations doivent être lisibles',
            label: 'Illisible',
        },
        UPLOAD_ERROR: {
            description: 'Une erreur semble s’être produite avec ce document, nous ne parvenons pas à l’ouvrir. Nous vous invitons à recommencer, et sommes désolés pour la gêne occasionnée.',
            label: 'Problème d’upload',
        },
        VITALE_CARD_INVALID: {
            description: 'Le document est invalide, merci d’ajouter votre carte vitale ou une attestation de sécurité sociale avec VOTRE numéro de sécurité sociale lisible.',
            label: 'Carte vitale invalide',
        },
        VTC_CARD_RECTO_INVALID: {
            description: 'Le document téléchargé n’est pas le bon, veuillez ajouter votre Carte VTC verso',
            label: 'Carte VTC Recto invalide',
        },
        VTC_CARD_VERSO_INVALID: {
            description: 'Le document téléchargé n’est pas le bon, veuillez ajouter votre Carte VTC verso',
            label: 'Carte VTC Verso invalide',
        },
        WRONG_BIRTH_DATE: {
            description: 'La date de naissance renseignée ne correspond pas à celle présente sur votre pièce d’identité.',
            label: 'Date de naissance incohérente',
        },
        WRONG_ID: {
            description: 'La pièce d’identité doit être la vôtre. Nous vous invitons à nous renvoyer le document avec votre pièce d’identité.',
            label: 'Mauvaise pièce d’identité',
        },
        WRONG_MARITAL_STATUS: {
            description: 'Le terme employé pour votre situation matrimoniale n’est pas accepté et le CFE (centre de formalités des entreprises) risque de refuser votre dossier. Si vous êtes séparé·e, nous vous invitons à préciser si vous êtes célibataire, divorcé·e ou veuf·ve.',
            label: 'Mention non conforme',
        },
    },
};
